import Client from './client';

const client = {
    clientModel: Client
};

export default client;
